<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout">
			<div class="md-layout-item md-small-size-100 md-size-75">
				<el-tabs v-model="tabName" v-if="loaded">
					<el-tab-pane label="ការភ្នាល់ប្រចាំថ្ងៃ" name="first"></el-tab-pane>
					<el-tab-pane label="ការភ្នាល់ប្រចាំខែ" name="second"></el-tab-pane>
					<el-tab-pane label="ការភ្នាល់ដោយជ្រើសរើសកាលបរិច្ឆេទ" name="third"></el-tab-pane>
				</el-tabs>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-25 text-right">
				<md-button class="md-raised md-primary" @click="refresh()">ធ្វើបច្ចប្បន្នភាពទិន្នន័យ</md-button>
			</div>
		</div>
		<div v-if="tabName == 'first' && loaded">

			<md-table v-if="clientTodayList.length > 0">
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>ឈ្មោះចូលប្រព័ន្ធ</md-table-head>
					<md-table-head>ព័ត៌មាន</md-table-head>
					<md-table-head>ទឹកប្រាក់នៅសល់</md-table-head>
					<md-table-head>ចំនួនភ្នាល់</md-table-head>
					<md-table-head>អតិថិជនឈ្នះ</md-table-head>
					<md-table-head>ក្រុមហ៊ុនចំណេញ</md-table-head>
				</md-table-row>

				<md-table-row v-for="(client, index) in clientTodayList" v-if="client.total_bet != 0">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>
						<router-link :to="'/clients/bet_provider_detail/' + client.hash">
							<md-icon>visibility</md-icon>
							<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
						</router-link>
						<b>{{client.username}} <md-icon class="verify" v-if="client.verified == 1">verified</md-icon></b> (m-{{config.orderlify(client.id)}})
					</md-table-cell>
					<md-table-cell><b>{{ client.name }} </b> ({{ client.phone }})</md-table-cell>
					<md-table-cell><b>{{ config.moneylify(client.balance) }} </b></md-table-cell>
					<md-table-cell>
						<b>{{ config.moneylify(client.total_bet * -1) }}</b>
					</md-table-cell>
					<md-table-cell><b>
						<span class="green" v-if="client.total_bet + client.total_win > 0">{{ config.moneylify(client.total_win) }}</span>
						<span class="late" v-else-if="client.total_bet + client.total_win < 0">{{ config.moneylify(client.total_win) }}</span>
						<span class="neutral" v-else>{{ config.moneylify(client.total_win) }}</span>
					</b></md-table-cell>
					<md-table-cell><b>
						<span class="green" v-if="client.total_bet + client.total_win < 0">{{ config.moneylify((client.total_bet + client.total_win) * -1) }}</span>
						<span class="late" v-else-if="client.total_bet + client.total_win > 0">{{ config.moneylify((client.total_bet + client.total_win) * -1) }}</span>
						<span class="neutral" v-else>{{ config.moneylify((client.total_bet + client.total_win) * -1) }}</span>
					</b></md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell><b>{{ config.moneylify(today_total_bet * -1) }}</b></md-table-cell>
					<md-table-cell><b>{{ config.moneylify(today_total_win) }}</b></md-table-cell>
					<md-table-cell><b>
						<span class="green" v-if="today_total_bet + today_total_win < 0">{{ config.moneylify((today_total_bet + today_total_win) * -1) }}</span>
						<span class="late" v-else-if="today_total_bet + today_total_win > 0">{{ config.moneylify((today_total_bet + today_total_win) * -1) }}</span>
						<span class="neutral" v-else>{{ config.moneylify(today_total_bet + today_total_win) }}</span>
					</b></md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="clientTodayList.length == 0 && loadMoreToday == false">មិនមានអតិថិជន</h4>
			<div class="places-buttons text-center" v-if="loadMoreToday">
				<md-button class="md-primary" @click="getBetToday(true)">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>

		<div v-if="tabName == 'second'">
			<md-table v-if="clientMonthlyList.length > 0">
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>ឈ្មោះចូលប្រព័ន្ធ</md-table-head>
					<md-table-head>ព័ត៌មាន</md-table-head>
					<md-table-head>ទឹកប្រាក់នៅសល់</md-table-head>
					<md-table-head>ចំនួនភ្នាល់</md-table-head>
					<md-table-head>អតិថិជនឈ្នះ</md-table-head>
					<md-table-head>ក្រុមហ៊ុនចំណេញ</md-table-head>
				</md-table-row>

				<md-table-row v-for="(client, index) in clientMonthlyList" v-if="client.total_bet != 0">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>
						<router-link :to="'/clients/bet_provider_detail/' + client.hash">
							<md-icon>visibility</md-icon>
							<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
						</router-link>
						<b>{{client.username}} <md-icon class="verify" v-if="client.verified == 1">verified</md-icon></b> (m-{{config.orderlify(client.id)}})
					</md-table-cell>
					<md-table-cell><b>{{ client.name }} </b> ({{ client.phone }})</md-table-cell>
					<md-table-cell><b>{{ config.moneylify(client.balance) }} </b></md-table-cell>
					<md-table-cell>
						<b>{{ config.moneylify(client.total_bet * -1) }}</b>
					</md-table-cell>
					<md-table-cell><b>
						<span class="green" v-if="client.total_bet + client.total_win > 0">{{ config.moneylify(client.total_win) }}</span>
						<span class="late" v-else-if="client.total_bet + client.total_win < 0">{{ config.moneylify(client.total_win) }}</span>
						<span class="neutral" v-else>{{ config.moneylify(client.total_win) }}</span>
					</b></md-table-cell>
					<md-table-cell><b>
						<span class="green" v-if="client.total_bet + client.total_win < 0">{{ config.moneylify((client.total_bet + client.total_win) * -1) }}</span>
						<span class="late" v-else-if="client.total_bet + client.total_win > 0">{{ config.moneylify((client.total_bet + client.total_win) * -1) }}</span>
						<span class="neutral" v-else>{{ config.moneylify((client.total_bet + client.total_win) * -1) }}</span>
					</b></md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell><b>{{ config.moneylify(monthly_total_bet * -1) }}</b></md-table-cell>
					<md-table-cell><b>{{ config.moneylify(monthly_total_win) }}</b></md-table-cell>
					<md-table-cell><b>
						<span class="green" v-if="monthly_total_bet + monthly_total_win < 0">{{ config.moneylify((monthly_total_bet + monthly_total_win)*-1) }}</span>
						<span class="late" v-else-if="monthly_total_bet + monthly_total_win > 0">{{ config.moneylify((monthly_total_bet + monthly_total_win)*-1) }}</span>
						<span class="neutral" v-else>{{ config.moneylify((monthly_total_bet + monthly_total_win)*-1) }}</span>
					</b></md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="clientMonthlyList.length == 0 && loadMoreMonthly == false">មិនមានអតិថិជន</h4>
			<div class="places-buttons text-center" v-if="loadMoreMonthly">
				<md-button class="md-primary" @click="getBetMonthly(true)">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>

		<div v-if="tabName == 'third'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-50 md-size-33">
					<md-field>
						<label>ថ្ងៃចាប់ផ្តើម</label>
						<md-input type="text" v-model="start_date" style="display:none" />
						<datetime type="datetime" v-model="start_date" auto></datetime>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-50 md-size-33">

					<md-field>
						<label>ថ្ងៃបញ្ចប់</label>
						<md-input type="text" v-model="end_date" style="display:none" />
						<datetime type="datetime" v-model="end_date" auto></datetime>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-33">
					<md-button class="md-raised md-primary" style="width:100%" @click="getBetRange()">បង្ហាញ</md-button>
				</div>
			</div>
			<md-table v-if="clientRangeList.length > 0">
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>ឈ្មោះចូលប្រព័ន្ធ</md-table-head>
					<md-table-head>ព័ត៌មាន</md-table-head>
					<md-table-head>ទឹកប្រាក់នៅសល់</md-table-head>
					<md-table-head>ចំនួនភ្នាល់</md-table-head>
					<md-table-head>អតិថិជនឈ្នះ</md-table-head>
					<md-table-head>ក្រុមហ៊ុនចំណេញ</md-table-head>
				</md-table-row>

				<md-table-row v-for="(client, index) in clientRangeList" v-if="client.total_bet != 0">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>
						<router-link :to="'/clients/bet_provider_detail/' + client.hash">
							<md-icon>visibility</md-icon>
							<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
						</router-link>
						<b>{{client.username}} <md-icon class="verify" v-if="client.verified == 1">verified</md-icon></b> (m-{{config.orderlify(client.id)}})
					</md-table-cell>
					<md-table-cell><b>{{ client.name }} </b> ({{ client.phone }})</md-table-cell>
					<md-table-cell><b>{{ config.moneylify(client.balance) }} </b></md-table-cell>
					<md-table-cell>
						<b>{{ config.moneylify(client.total_bet * -1) }}</b>
					</md-table-cell>
					<md-table-cell><b>
						<span class="green" v-if="client.total_bet + client.total_win > 0">{{ config.moneylify(client.total_win) }}</span>
						<span class="late" v-else-if="client.total_bet + client.total_win < 0">{{ config.moneylify(client.total_win) }}</span>
						<span class="neutral" v-else>{{ config.moneylify(client.total_win) }}</span>
					</b></md-table-cell>
					<md-table-cell><b>
						<span class="green" v-if="client.total_bet + client.total_win < 0">{{ config.moneylify((client.total_bet + client.total_win) * -1) }}</span>
						<span class="late" v-else-if="client.total_bet + client.total_win > 0">{{ config.moneylify((client.total_bet + client.total_win) * -1) }}</span>
						<span class="neutral" v-else>{{ config.moneylify((client.total_bet + client.total_win) * -1) }}</span>
					</b></md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell><b>{{ config.moneylify(range_total_bet * -1) }}</b></md-table-cell>
					<md-table-cell><b>{{ config.moneylify(range_total_win) }}</b></md-table-cell>
					<md-table-cell><b>
						<span class="green" v-if="range_total_bet + range_total_win < 0">{{ config.moneylify((range_total_bet + range_total_win)*-1) }}</span>
						<span class="late" v-else-if="range_total_bet + range_total_win > 0">{{ config.moneylify((range_total_bet + range_total_win)*-1) }}</span>
						<span class="neutral" v-else>{{ config.moneylify((range_total_bet + range_total_win)*-1) }}</span>
					</b></md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="clientRangeList.length == 0 && loadMoreRange == false">មិនមានអតិថិជន</h4>
			<div class="places-buttons text-center" v-if="loadMoreRange">
				<md-button class="md-primary" @click="getBetRange(true)">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>

	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		mounted() {
			let type = this.$store.state.authentication.account_type;
			if (type == 'sa' || type == 'oa') {
				return;
			} else {
				this.$router.push('/dashboard');
			}
		},
		created() {

			this.getBetToday();

		},
		watch: {
			'tabName': function() {
				if(this.tabName == 'second') {
					this.getBetMonthly();
				}
			}
		},
		data() {
			return {
				tabName: "first",
				loaded: false,
				secondLoaded: false,
				start_date: "",
				end_date: "",

				loadMoreToday: false,
				loadMoreMonthly: false,
				loadMoreRange: false,
				clientTodayList: [],
				clientMonthlyList: [],
				clientRangeList: []

			}
		},
		computed: {
			today_total_bet() {
				let total = 0;
				for(let i = 0; i< this.clientTodayList.length; i++) {
					total = total + this.clientTodayList[i].total_bet;
				}
				return total;
			},
			today_total_win() {
				let total = 0;
				for(let i = 0; i< this.clientTodayList.length; i++) {
					total = total + this.clientTodayList[i].total_win;
				}
				return total;
			},
			monthly_total_bet() {
				let total = 0;
				for(let i = 0; i< this.clientMonthlyList.length; i++) {
					total = total + this.clientMonthlyList[i].total_bet;
				}
				return total;
			},
			monthly_total_win() {
				let total = 0;
				for(let i = 0; i< this.clientMonthlyList.length; i++) {
					total = total + this.clientMonthlyList[i].total_win;
				}
				return total;
			},
			range_total_bet() {
				let total = 0;
				for(let i = 0; i< this.clientRangeList.length; i++) {
					total = total + this.clientRangeList[i].total_bet;
				}
				return total;
			},
			range_total_win() {
				let total = 0;
				for(let i = 0; i< this.clientRangeList.length; i++) {
					total = total + this.clientRangeList[i].total_win;
				}
				return total;
			}
		},
		methods: {
			getBetToday(more = false) {
				this.$http.post(this.config.api + "/admin/get/client_bet_stat/day",{
					offset: more == true ? this.clientTodayList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == 50) this.loadMoreToday = true;
					else this.loadMoreToday = false;
					this.clientTodayList = more ? this.clientTodayList.concat(data.body.data) : data.body.data;
					// this.clientList = data.body.data;
				})
			},
			getBetMonthly(more = false) {
				this.$http.post(this.config.api + "/admin/get/client_bet_stat/month",{
					offset: more == true ? this.clientMonthlyList.length : 0
				}).then(data => {
					this.secondLoaded = true;
					if (data.body.data.length == 50) this.loadMoreMonthly = true;
					else this.loadMoreMonthly = false;
					this.clientMonthlyList = more ? this.clientMonthlyList.concat(data.body.data) : data.body.data;
					// this.clientList = data.body.data;
				})
			},
			getBetRange(more = false) {
				let start_date = (new Date(this.start_date)).getTime();
				let end_date = (new Date(this.end_date)).getTime();

				this.$http.post(this.config.api + "/admin/get/client_bet_stat/range",{
					start_date: start_date,
					end_date: end_date,
					offset: more == true ? this.clientRangeList.length : 0
				}).then(data => {
					this.thirdLoaded = true;
					if (data.body.data.length == 50) this.loadMoreRange = true;
					else this.loadMoreRange = false;
					this.clientRangeList = more ? this.clientRangeList.concat(data.body.data) : data.body.data;
					// this.clientList = data.body.data;
				})
			},
			refresh() {
				if(this.tabName == 'first') {
					this.getBetToday();
				} else if (this.tabName == 'second') {
					this.getBetMonthly();
				} else if(this.tabName == 'third') {
					this.getBetRange();
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/BetReports/View.vue